<div>
  <h2 class="heading">Teltonika Reporting</h2>
  <div class="buttons">
    <button mat-raised-button (click)="goToRoute('/Teltonika/Reporting/devices')">
      Teltonika Bulk Devices Report
    </button>
    <button mat-raised-button (click)="goToRoute('/Teltonika/Reporting/connected-devices')">
      Teltonika Connected Devices Report
    </button>
  </div>
</div>